import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Home/PendingPurchaseIndent';

const PendingPurchaseIndent = () => ((orgContainer(InnerComponent)));

export default PendingPurchaseIndent;
